type MoveOrganizationalUnitError = {
  cycle: boolean;
  duplicateName: boolean;
};

const moveOrganizationalUnitError: MoveOrganizationalUnitError = {
  cycle: false,
  duplicateName: false,
};

export type { MoveOrganizationalUnitError };

export { moveOrganizationalUnitError };
